<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters 
        :bloodDegrees="degree_blood.map((e,i) => ({title:e.name, id:e.name}))"
        @get-report="submitReport"  
      />
    </div>

    <div class="col-md-12 px-0 d-flex justify-content-end">
      <div class="col-md-2 px-0">
        <v-select
          outlined
          dense
          :label="'Exibindo ' + itemFilter + ' resultados'"
          :items="computedResults"
          item-text="title"
          item-value="id"
          v-model="itemFilter"
        ></v-select>
      </div>
    </div>

    <div class="col-md-12 px-0">
      <the-table 
        id="production-record-report"
        :dataItems="computedProduction.filter((e,i) => i < itemFilter)"
        :headers="headersForTable"
      />
    </div>

    <button-export
      :print="true"
      @print="PDFPrint"
      v-if="results.length"
      :excel="true"
      :headers="excel_fields"
      :data="computedProduction"
      :title="'Recorde de Produção'"
      @export-pdf="PDFExport"
    />
  </div>
</template>

<script>
import ReportFilters from "./ReportFilters";
import TheTable from "@/components/layout/TheTable";
import ButtonExport from "@/components/layout/ButtonExport";
import {mapState, mapActions} from "vuex";

import { exportOfficialTablePdf } from "@/utils/officialPdf";
export default {
  name:"ProductionRecord",
  components: {
    ReportFilters,
    TheTable,
    ButtonExport
  },
  data() {
    return {
      headersForTable:[
        {text:"Animal", value:"animal_name", sortable:true},
        {text:"Registro", value:"animal_register", sortable:true},
        {text:"Comp Racial", value:"degree_blood", sortable:true},
        {text:"Idade em Meses", value:"age", type:"number", sortable:true},
        {text:"Duração em Dias", value:"duration_in_days", type:"number", sortable:true},
        {text:"Ordem", value:"order", type:"number", sortable:true},
        {text:"Produção", value:"production", type:"number", sortable:true},
      ],
      animalsModal:false,
      serviceModal:{},
      excel_fields:{
        "Animal":"animal_name",
        "Registro":"animal_register",
        "Comp Racial":"degree_blood",
        "Idade em Meses":"age",
        "Duração em Dias":"duration_in_days",
        "Ordem":"order",
        "Produção":"production"
      },
      filters:{},
      itemFilter:10
    }
  },
  computed: {
    ...mapState("production_record_report_single", ["results"]),
    ...mapState("animals", ["degree_blood"]),
    computedProduction() {
      if(this.results) {
        return this.results.map(e => ({
          ...e,
          animal_name:e.animal.name,
          animal_register:e.animal.register,
          degree_blood:e.animal.degree_blood,
        }));
      }
      else {
        return [];
      }
    },
    computedResults() {
      return [
        {title:"20", id:20},
        {title:"40", id:40},
        {title:"60", id:60},
        {title:"80", id:80},
        {title:"100", id:100},
      ]
    }
  },
  methods: {
    ...mapActions("production_record_report_single", ["actionGetProductionRecord"]),
    async submitReport(filter) {
      this.filters = filter;
      await this.actionGetProductionRecord(filter);
    },
    async PDFExport(print = false) {
      const { date_birth, date_explanation, order, base_value, blood_degree } = this.filters;
      return exportOfficialTablePdf({
        table: "#production-record-report", title: "RECORDE DE PRODUÇÃO",
        details: [
          `Parto: ${date_birth || "-"}    Encerramento: ${date_explanation || "-"}    Ordem: ${order || "-"}`,
          `Valor base: ${base_value || "-"}    Grau de sangue: ${blood_degree || "-"}`
        ],
        filename: `recorde_producao_${Date.now()}.pdf`, print
      });
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
  },
}
</script>

<style>

</style>
